import React from 'react'
import "../Css/Footer.css"
import { Col, Container, Row } from 'react-bootstrap'
import FooterLogo from "../aseets/img/FooterLogo.png"
import { SlLocationPin } from "react-icons/sl";
import { MdMailOutline } from "react-icons/md";
import { IoCall } from "react-icons/io5";

import { Link } from 'react-router-dom'



const Footer = () => {
  return (
    <React.Fragment>
        <div className='footerMainDiv'>
            <Container>
                <Row >
                    <Col lg={5} md={5} sm={12}>
                    <div className='footerSubTitle'>
                    The connection you’ve been waiting for starts here!
                    </div>
                    <a className='contacusLink' href='tel:8573020150' >
                   <IoCall className='contactIcon' /> ‪(857) 302-0150‬
                    </a>
                    </Col>
                    <Col lg={7} md={7} sm={12} className='emailCol'>
                    <div className='footerEmailDiv'>
                    <div className='footerAddresh'>
                    <SlLocationPin className='footerIcon' /> <span>5900 Balcones Dr, Ste 100
                    Austin TX 78731 USA</span>
                    </div>
                    <div className='footerAddresh' >
                    <Link to="mailto:info@platinummatches.com">
                    <MdMailOutline className='footerIcon' /> <span>info@platinummatches.com</span>
                    </Link>
                    </div>
                    </div>
                    </Col>
                </Row>
             
                {/* <div className='footerTitle'>
                Where Your Ideal Match Awaits!
                </div> */}
                {/* <div className='shareIconDivFooter'>
                           <div>
                            <Link to="#">
                             <FaFacebook />
                            </Link>
                           </div>
                           <div>
                            <Link to="#">
                             <FaInstagram  />
                            </Link>
                           </div>
                           <div>
                            <Link to="#">
                             <FaXTwitter  />  
                            </Link>
                           </div>
                           
                        </div> */}
               
                <hr className='footerHr' />
                {/* <Row>
                    <Col lg={6} md={6}>
                    
                    </Col>
                    <Col lg={6} md={6}>
                    <div className='privacyPlycDiv'>
                    Privacy Policy
                    Terms & conditions
                    </div>
                    </Col>
                </Row> */}
                <Row className='footerRow'>
                    <Col lg={4}>
                    <div className='footerNavLinkDiv'>
                    {/* <div>
                        <Link className='footerTitle' to="/">
                        Home
                        </Link>
                    </div> */}
                    <div>
                        <Link className='footerTitle' to="/about-us">
                        About Us
                        </Link>
                    </div>
                    <div>
                        <Link className='footerTitle' to="/membership">
                        Membership
                        </Link>
                    </div>
                    <div>
                        <Link className='footerTitle' to="/testimonial">
                        Testimonials
                        </Link>
                    </div>
                    <div>
                        <Link className='footerTitle' to="/contact-us">
                        Contact Us
                        </Link>
                    </div>
                </div>
                    </Col>
                    <Col lg={4}>
                    
                    <div className='footerlogoDiv'>
                    <Link to="/">
                    <img className='footerImg' src={FooterLogo} alt='logo' />
                    </Link>
                </div>
                
                    </Col>
                    <Col lg={4}>
                    <div className='copyRightDiv'>
                    ©Copyright 2024. All Rights Reserved 
                    </div>
                    </Col>
                </Row>
            </Container>
        </div>
    </React.Fragment>
  )
}

export default Footer